import React, { useState, useEffect } from "react";
import BenefitCard from "./BenefitCard";
import styles from "../../../components/styles/benifits.module.css";

import LowerITCostsIcon from "../../../assets/images/Lower IT Costs.webp";
import OperationalEfficiencyIcon from "../../../assets/images/Operational Efficiency.webp";
import ResourceAllocationIcon from "../../../assets/images/Better Resource Allocation.webp";
import UpToDateTechnologyIcon from "../../../assets/images/Up to date technology photo_enhanced_enhanced.webp";
import NightShiftsIcon from "../../../assets/images/Allowance for night shifts.webp";

const BenefitsSection = () => {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  
  useEffect(() => {
    const imagesList = [
      LowerITCostsIcon,
      OperationalEfficiencyIcon,
      ResourceAllocationIcon,
      UpToDateTechnologyIcon,
      NightShiftsIcon
    ];
    
    const loadedImages = Array(imagesList.length).fill(false);
    let loaded = 0;
    
    imagesList.forEach((src, index) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        loadedImages[index] = true;
        loaded++;
        if (loaded === imagesList.length) {
          setImagesLoaded(true);
        }
      };
      img.onerror = () => {
        loaded++;
        if (loaded === imagesList.length) {
          setImagesLoaded(true);
        }
      };
    });
    
    const timer = setTimeout(() => {
      setImagesLoaded(true);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);
  
  const benefitsData = [
    {
      icon: LowerITCostsIcon,
      title: "ITコストの削減",
      description:
        "現在、熟練IT人材が世界的に不足していることから、優秀な人材を雇用し社内でそのリソースを維持することはコスト負担増大の一因となりえます。マネージドITサービスへの切り替えによって比較的容易に、また大幅にIT関連コストを削減できます。",
    },
    {
      icon: OperationalEfficiencyIcon,
      title: "運用効率",
      description:
        "組織が拡大するにつれて、社内のITチームがキャパオーバーになってしまうことがあります。ITサービスをアウトソーシングすることによって、御社のテクノロジーインフラストラクチャのパフォーマンス、効率、信頼性を最大限にまで高めることができます。 ",
    },
    {
      icon: ResourceAllocationIcon,
      title: "より良いリソース配分",
      description:
        "マネージドサービスプロバイダーを利用すると、高度なIT専門知識を活用できるため、社内のリソース配分を最適化し、組織全体でより大きな価値を生み出せるようになります。",
    },
    {
      icon: UpToDateTechnologyIcon,
      title: "最新技術",
      description:
        "システム障害により、中小企業では1件あたり82,000ドルから256,000ドルの損害を被る可能性があります。マネージドITサービスプロバイダーとして当社はテクノロジーの安全性、信頼性、および最高の効率性を維持できるよう支援いたします。",
    },
    {
      icon: NightShiftsIcon,
      title: "成長の機会",
      description:
        "複雑なテクノロジーに関する決定を信頼に足るITサービスプロバイダーに委託することで、御社はコアコンピテンシーに集中し、成長の機会を手にすることができます。",
    },
  ];
  
  return (
    <section className={styles["benefits-section"]}>
      <h2 className={styles["benefits-title"]}>
        <span className={styles["benefits-text"]}>利点</span> そして{" "}
        <span className={styles["features-text"]}>特徴</span>
      </h2>

      <div className={styles["benefits-cards-container"]}>
        <div className={styles["benefits-top-row"]}>
          {benefitsData.slice(0, 3).map((benefit, index) => (
            <div key={index} className={styles["benefit-item"]}>
              <BenefitCard icon={benefit.icon} />
              <h3 className={styles["benefit-title-below"]}>{benefit.title}</h3>
              <p className={styles["benefit-description-below"]}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className={styles["benefits-bottom-row"]}>
          {benefitsData.slice(3, 5).map((benefit, index) => (
            <div key={index} className={styles["benefit-item"]}>
              <BenefitCard icon={benefit.icon} />
              <h3 className={styles["benefit-title-below"]}>{benefit.title}</h3>
              <p className={styles["benefit-description-below"]}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
